// extracted by mini-css-extract-plugin
export default {"service-card":"ServiceCard_service-card__bCaE1","icon":"ServiceCard_icon__+GnnL","description":"ServiceCard_description__NF1W9"};